/**
 * The available type of loader.
 */
export const PROGRESS_TYPE = {
    CIRCULAR: 'circular',
    LINEAR: 'linear',
};
